import axios from 'axios';

const API_BASE_URL = '/public/api/v1';

export default {
  async fetchLandingContent(locale = 'vi') {
    const response = await axios.get(`${API_BASE_URL}/landing`, {
      params: { locale },
    });
    return response.data;
  },

  async fetchPagesTree(locale = 'vi', pageType = 'docs') {
    const response = await axios.get(`${API_BASE_URL}/pages/tree`, {
      params: { locale, page_type: pageType },
    });
    return response.data;
  },

  async fetchPage(locale = 'vi', pageType = 'docs', slug = '') {
    const response = await axios.get(`${API_BASE_URL}/pages/${slug || 'index'}`, {
      params: { locale, page_type: pageType },
    });
    return response.data;
  },

  async submitConsultation(payload) {
    const response = await axios.post(`${API_BASE_URL}/landing/consultations`, {
      consultation: payload,
    });
    return response.data;
  },
};
